<script setup lang="ts">
import { defineProps } from 'vue';
import Select from 'primevue/select';

const props = defineProps<{
  error?: string | undefined;
  textWrap?: boolean;
}>();
</script>

<template>
  <label class="text-bluegray-600 block flex-1 text-left text-sm font-normal" :class="$attrs.class">
    <slot></slot>

    <Select
      v-bind="$attrs"
      class="mt-1 block w-full"
      :class="{ 'text-wrap-enabled': props.textWrap !== false }"
      :invalid="!!error"
      appendTo="body"
      scrollHeight="20rem"
    />

    <small class="mt-1 text-left text-xs text-red-600">
      {{ error }}
    </small>
  </label>
</template>

<style scoped>
.text-wrap-enabled :deep(.p-select-label) {
  white-space: normal;
  word-wrap: break-word;
}

.text-wrap-enabled :deep(.p-select-option) {
  white-space: normal;
  word-wrap: break-word;
}
</style>
